import { Platform } from "../Platform";
import { AsyncStorageType } from "./types";
import defaultApi from "./AsyncStorage.default";
import iosApi from "./AsyncStorage.ios";

/**
 * An asynchronous key-value store that handles JSON serialization and deserialization on its own.
 */
export const AsyncStorage = Platform.select<AsyncStorageType>({
  default: defaultApi,
  ios: iosApi,
}) as AsyncStorageType;
